import { throwErrorForDev, outputDeprecationWarning } from './outputHelpers';

/**
 * Logs a warning or throws an error if one or more props are invalid.
 * This will no-op on Production builds.
 * @param {*} props - props to validate
 */
export default function handlePropValidation({
    title,
    whiteOverlay,
    onClose,
    primaryButtonProps,
    secondaryButtonProps,
}) {
    if (!title?.trim()?.length) {
        throwErrorForDev(
            'You must supply a title prop. This is built into the modal'
        );
    }

    if (typeof whiteOverlay !== 'undefined') {
        outputDeprecationWarning(
            'whiteOverlay prop is deprecated. Stop using it ASAP'
        );
    }

    if (
        typeof secondaryButtonProps === 'object' &&
        typeof primaryButtonProps !== 'object'
    ) {
        throwErrorForDev(
            'primaryButtonProps must be set if you have set secondaryButtonProps. Secondary button should only render when a Primary button is present.'
        );
    }

    if (
        typeof primaryButtonProps !== 'object' &&
        typeof onClose !== 'function'
    ) {
        throwErrorForDev(
            'onClose prop must be set if no primary button exists. Modals must have a way for users to dismiss or navigate away.'
        );
    }
}
